import FullWidthImageSlider from "../../../../src/components/FullWidthImageSlider";
import SnappySlider from "../../../../src/components/SnappySlider";
import SnappySlide from "../../../../src/components/SnappySlider/SnappySlide";
import * as React from 'react';
export default {
  FullWidthImageSlider,
  SnappySlider,
  SnappySlide,
  React
};